let page_lng = "es";
/*
let page_vars=getUrlVars();

if(page_vars["lng"])
{
	page_lng=page_vars["lng"];
}

function getUrlVars() 
{
	var vars = {};
	var parts = window.location.href.replace(/[?&#]+([^=&#]+)=([^&#]*)/gi, function(m,key,value) 
	{
		vars[key] = value;
	});
	return(vars);
}
*/ function show_lng(lng) {
    document.querySelectorAll(".lng").forEach((element)=>{
        element.style.display = 'none';
    });
    document.querySelectorAll(".lng_" + lng).forEach((element)=>{
        element.style.display = 'inline-block';
    });
}
function get_messages() {
    window.addEventListener("message", (event)=>{
        if (event.data.msg == "farmaval_data") {
            if (event.data.conditions) for (const [key, value] of Object.entries(event.data.conditions))document.querySelectorAll("." + key + "_" + value).forEach((element)=>{
                element.classList.remove("hide");
            });
            if (event.data.values) {
                for (const [key, value] of Object.entries(event.data.values))if (value != null) document.querySelectorAll("[aria-data='" + key + "']").forEach((element)=>{
                    element.innerHTML = value;
                    element.classList.remove("hide");
                });
            }
            document.querySelector(".footer_signature").setAttribute("src", event.data.values["pharm_admin_signature"]);
            if (event.data.values["pdata_logo"]) document.querySelector(".header_logo").setAttribute("src", event.data.values["pharm_logo"]);
            else document.querySelector(".header_logo").classList.add("hide");
        }
    }, false);
}
function load() {
    show_lng(page_lng);
    get_messages();
    window.parent.postMessage("farmaval_send_data");
    /*
    document.querySelectorAll("[aria-list]").forEach(element=>{
		const list=element.getAttribute("aria-list").split(element.getAttribute("aria-list-sep"));
		let type=1;
		//if(element.getAttribute("aria-type")=="double") type=2;

		for(let a=0;a<list.length;a+=type)
		{
			if(list[a]!="")
			{	
				let li=document.createElement("LI");
				li.innerHTML=list[a];
				element.append(li);
			}
		}
	});
	*/ //window.print();
    document.querySelectorAll(".btn_lng").forEach((element)=>{
        element.addEventListener('click', function(e) {
            e.preventDefault();
            show_lng(element.getAttribute("href"));
        }, false);
    });
    document.getElementById("btn_close").addEventListener('click', function(e) {
        e.preventDefault();
        window.parent.postMessage("farmaval_close_report");
    }, false);
}
document.addEventListener("DOMContentLoaded", load, false);

//# sourceMappingURL=report.35654014.js.map
